import { FC } from 'react';
import styled from '@emotion/styled';
import Typography from 'aquilla/core/atoms/Typography';
import { mediaQuery, Spacings } from '@styles/index';
import Image from '@base/Image';
import ShowCase from 'aquilla/core/molecules/ShowCase';
import { nFormatter } from '@utils/textHelper';
import { ISuccessStoryBlock } from '../../../types/success-story';

const REVIEW_QUOTE_IMAGE = 'reviews-quote.svg';

interface ILearnerReviewsProps {
  data: ISuccessStoryBlock;
}

const LearnerReviews: FC<ILearnerReviewsProps> = ({ data }) => {
  return (
    <LearnerReviewsContainer>
      <ShowCase title={data.extraBlockInfo.blockHeader} itemsPerSlide={3}>
        {data.data?.map((item, index) => {
          return (
            <LearnerReviewsItem key={String(index)}>
              <LearnerReviewsQuoteImageContainer>
                <Image
                  src={REVIEW_QUOTE_IMAGE}
                  alt="quote"
                  height={120}
                  width={120}
                />
              </LearnerReviewsQuoteImageContainer>
              <LearnerReviewsLearnerImageContainer>
                <LearnerReviewsLearnerImageWraper>
                  <LearnerReviewsLearnerImage
                    src={item.user.avatar}
                    width="60"
                    height="60"
                    alt="learner-review-learner"
                  />
                </LearnerReviewsLearnerImageWraper>
              </LearnerReviewsLearnerImageContainer>
              <LearnerReviewsTitle variant="h5">
                {item.others}
              </LearnerReviewsTitle>
              <LearnerReviewsItemEmptySpace />
              <LearnerReviewsLearnerName variant="h5">{`${item.user.firstName} ${item.user.lastName}`}</LearnerReviewsLearnerName>
              <LearnerReviewsLearnerDetails
                variant="p3"
                color="var(--color-text-secondary)"
              >{`${item.goal.name} • ${nFormatter(
                item.user.learnerMinutes
              )} learning mins`}</LearnerReviewsLearnerDetails>
            </LearnerReviewsItem>
          );
        })}
      </ShowCase>
    </LearnerReviewsContainer>
  );
};

const LearnerReviewsContainer = styled.div`
  margin-top: ${Spacings.SPACING_12B};

  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const LearnerReviewsLearnerImageContainer = styled.div`
  margin-top: ${Spacings.SPACING_15B};
`;

const LearnerReviewsLearnerImageWraper = styled.div`
  display: inline-block;
  > * {
    border: ${Spacings.SPACING_1B} solid var(--color-i-white) !important;
    border-radius: ${Spacings.SPACING_2B};
  }
`;
const LearnerReviewsLearnerImage = styled(Image)`
  border-radius: ${Spacings.SPACING_2B};
`;

const LearnerReviewsItemEmptySpace = styled.div`
  flex: 1;
`;

const LearnerReviewsQuoteImageContainer = styled.div`
  position: absolute;
  top: 12px;
  left: 20px;
  height: 86px;
  width: 98px;
  z-index: 0;
  img {
    height: 120px;
    width: 120px;
  }
  ${mediaQuery.uptoMobile} {
    top: 20px;
    left: 20px;

    img {
      z-index: 0;
      height: 75px;
      width: 84px;
    }
  }
`;

const LearnerReviewsItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 352px;
  height: 100%;

  ${mediaQuery.uptoMobile} {
    width: 288px;
  }
`;

const LearnerReviewsTitle = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
  margin-right: ${Spacings.SPACING_4B};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
`;

const LearnerReviewsLearnerName = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
`;

const LearnerReviewsLearnerDetails = styled(Typography)`
  margin-top: ${Spacings.SPACING_1B};
`;

export default LearnerReviews;
